import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white' | 'accent';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    // Deep Teal - Primary brand color
    primary: 'bg-brand text-white hover:bg-brand-dark focus:ring-brand shadow-brand',
    // Vibrant Coral - Secondary color for CTAs
    secondary: 'bg-secondary text-white hover:bg-secondary-dark focus:ring-secondary shadow-secondary hover:scale-105 active:scale-100',
    // Outline with brand color
    outline: 'border-2 border-brand text-brand hover:bg-brand/10 focus:ring-brand',
    // White button
    white: 'bg-white text-gray-800 hover:bg-gray-100 focus:ring-white shadow-lg',
    // Warm Gold - Accent color
    accent: 'bg-accent text-white hover:bg-accent-dark focus:ring-accent shadow-accent'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  return <button className={combinedClassName} {...props} data-id="element-1346">
      {children}
    </button>;
}